/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useCallback } from "react";
import { LinkProps } from "@tvg/fuse-link";
import { StyledBrand, StyledLi } from "./brand.styles";
export interface BrandProps extends Omit<LinkProps, "onClick"> {
  brand: string;
  onClick: (brand: string) => void;
}

const Brand = ({ brand, onClick, ...props }: BrandProps) => {
  const handleClick = useCallback(() => {
    onClick(brand);
  }, [brand, onClick]);

  return (
    <StyledLi>
      <StyledBrand
        {...props}
        href={`/search/${brand}`}
        size="medium"
        underline={false}
        onClick={handleClick}
      >
        {brand}
      </StyledBrand>
    </StyledLi>
  );
};

export default React.memo(Brand);
